import { Controller } from "stimulus";

// Connects to data-controller="quill"
export default class extends Controller {
  static targets = [
    "editor"
  ]

  connect() {
    // var Block = Quill.import('blots/block');
    // Block.tagName = 'DIV';
    // Block.className = 'pre';
    // Quill.register(Block, true);

    // console.log("Quill!!")
    const quill = new Quill(this.editorTarget, {
      modules: {
        toolbar: [
          ['bold', 'underline', 'strike'],
          ['link'],
          // [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'color': [] }, { 'background': [] }],
        ],
      },
      scrollingContainer: document.documentElement,
      //theme: 'snow',
      theme: 'bubble',
    });
    let tooltip = quill.theme.tooltip;
    let input = tooltip.root.querySelector("input[data-link]");
    input.dataset.link = 'URLを入力してくだい';
    quill.on('text-change', () => {
      // console.log(quill.root.innerHTML);
      // document.querySelector('#customer_memo').value = quill.root.innerHTML;
      this.element.querySelector("input[type='hidden']").value = quill.root.innerHTML;
    });
  }
}
